import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { get as _get } from "lodash";

import { showAlertMessage } from "./formElements";

import { doGetDeepResearchReport } from "../../redux/services/campaign";
import { updateLoadingState } from "../../redux/actions/application";

class DeepResearchReportButton extends Component {

  _handleDeepResearch = async () => {
    const { campaignId, updateLoadingState, intl } = this.props;

    if (!campaignId) {
      showAlertMessage(intl.formatMessage({ id: "error.invalid_campaign", defaultMessage: "Invalid campaign ID." }));
      return false;
    }

    try {

      if (typeof updateLoadingState === "function") { updateLoadingState(true); }

      const response = await doGetDeepResearchReport(campaignId);
      if (_get(response, "flag", false) === true) {
        showAlertMessage(_get(response, "message", "Analysis report generated successfully."), "success");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while generating analysis report."));
      }
    } catch (err) {
      showAlertMessage((err.message || "Something went wrong while generating analysis report."));
    } finally {
      if (typeof updateLoadingState === "function") { updateLoadingState(false); }
    }
  };

  _handleViewReport = () => {
    const { campaignId, intl } = this.props;

    if (!campaignId) {
      showAlertMessage(intl.formatMessage({ id: "error.invalid_campaign", defaultMessage: "Invalid campaign ID." }));
      return false;
    }

    window.open(`/campaigns/view-deep-research-report/${campaignId}`, "_blank");
  };

  render() {
    const { campaignId, reportStatus } = this.props;

    return (
      <>
        {(reportStatus === 0) && (
          <button
            className="btn btn-outline-primary waves-effect"
            onClick={() => this._handleDeepResearch()}
          >
            <FormattedMessage id="campaign_dashboard.btn.deep_research_report" defaultMessage="Generate Analysis Report" />
          </button>
        )}
        {(reportStatus === 1) && (
          <Link
            to={`/campaigns/view-deep-research-report/${campaignId}`}
            className="btn btn-outline-primary waves-effect"
          >
            <FormattedMessage id="campaign_dashboard.btn.view_deep_research_report" defaultMessage="View Analysis Report" />
          </Link>
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateLoadingState: (data) => dispatch(updateLoadingState(data)),
});

export default connect(null, mapDispatchToProps)(injectIntl(DeepResearchReportButton));
